import moment from "moment";

// Excel date helpers: write real date cells (not text) so Excel's column filter
// groups the values by Year > Month > Day.

export const EXCEL_DATE_FORMAT = "dd/mm/yyyy";

// Excel serial day number for the calendar date of `value` (timezone safe). null when empty/invalid.
export const toExcelDate = (value) => {
  if (!value) return null;
  const date = moment(value);
  if (!date.isValid()) return null;
  return (Date.UTC(date.year(), date.month(), date.date()) - Date.UTC(1899, 11, 30)) / 86400000;
};

// ExcelJS: set a cell to a date value (or "-" when empty)
export const setExcelJsDateCell = (row, columnNumber, value) => {
  const serial = toExcelDate(value);
  const cell = row.getCell(columnNumber);
  if (serial === null) {
    cell.value = "-";
    return;
  }
  cell.value = serial;
  cell.numFmt = EXCEL_DATE_FORMAT;
};

// ExcelJS: enable the auto filter from the header row down to the last data row
export const setExcelJsAutoFilter = (worksheet, headerRow, lastDataRowNumber, columnCount) => {
  if (!worksheet || !headerRow) return;
  worksheet.autoFilter = {
    from: { row: headerRow.number, column: 1 },
    to: { row: Math.max(lastDataRowNumber || headerRow.number, headerRow.number), column: columnCount },
  };
};

// SheetJS (xlsx): convert the given columns (0 based) of an aoa worksheet into date cells
// and enable the auto filter on the header row.
export const applySheetJsDates = (XLSX, worksheet, dateColumns = [], headerRowIndex = 0) => {
  if (!worksheet || !worksheet["!ref"]) return worksheet;
  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  for (let r = headerRowIndex + 1; r <= range.e.r; r++) {
    for (const c of dateColumns) {
      const address = XLSX.utils.encode_cell({ r, c });
      const cell = worksheet[address];
      if (!cell || cell.v === "-" || cell.v === "" || cell.v === null || cell.v === undefined) continue;
      const parsed = moment(cell.v, ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", moment.ISO_8601], true);
      if (!parsed.isValid()) continue;
      worksheet[address] = { t: "n", v: toExcelDate(parsed), z: EXCEL_DATE_FORMAT };
    }
  }

  worksheet["!autofilter"] = {
    ref: XLSX.utils.encode_range({ s: { r: headerRowIndex, c: range.s.c }, e: { r: range.e.r, c: range.e.c } }),
  };
  return worksheet;
};
